import { useTranslation } from "react-i18next"
import React, { FC } from "react"

interface AppNameProps {
  appName: string
}

const TransAppName: FC<AppNameProps> = (props) => {
  const {
    appName,
  } = props

  const { t } = useTranslation()
  let app = appName
  if (app === 'other') {
    app = t('parts.app_name.other')
  } else if (app === 'no_operation') {
    app = t('parts.app_name.no_operation')
  }
  return (
    <>
      {app}
    </>
  )
}

export default TransAppName
